module.exports = __webpack_public_path__ + "static/media/vegetarian.f8274f0c.svg";